import { Box } from '@chakra-ui/react'

export function BoxBorder({ children }) {
  return (
    <Box border="1px solid" borderColor="#CFCFCF" px={4} py={2} bg="white">
      {children}
    </Box>
  )
}
